import React, { ReactNode, useCallback, useEffect, useState } from 'react'
import Select, {MultiValue, components, OptionProps} from 'react-select';
import { Tag } from './tags-api'

type Option = {
  value: number;
  label: string;
  color: string;
};

const tagToOption = (tag: Tag): Option => ({
  value: tag.id,
  label: tag.name,
  color: tag.color,
});

function TagOption(props: OptionProps<Option, true>) {
  const { data, isSelected } = props;
  
  return (
    <components.Option {...props} isSelected={false}>
        <div className="d-flex align-items-center gap-2">
            <span className={`text-${data.color} ${!isSelected ? 'fa fa-circle' : 'fa fa-check'}`}></span>
            {data.label}
        </div>
    </components.Option>
  );
};

export function TagFilter({tags, selected, onSelect}:{tags:Tag[], selected:number[], onSelect:(tags:number[])=>void}){
    const [inputValue, setInputValue] = useState('');
    const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(tags.map(tagToOption).filter(t => selected.includes(t.value)));
    const options = tags.map(tagToOption);

    const handleChange = (selected: MultiValue<Option>) => {
        onSelect(selected.map(t => t.value))
    };

    const TagControl = useCallback(({ children, ...props }:any) => {
        const plural = selectedOptions.length > 1 ? 's' : ''
        return <components.Control {...props}>
            {selectedOptions.length > 0 && <span className='px-3'>{selectedOptions.length} Tag{plural} Selecionada{plural}</span>} 
            {children}
        </components.Control>
    }, [selectedOptions])

    useEffect(()=>{
        setSelectedOptions(tags.map(tagToOption).filter(t => selected.includes(t.value)))
    }, [selected, tags])

    return <><Select 
        isMulti
        classNamePrefix='react-select-city'
        options={options}
        onChange={handleChange}
        placeholder={selectedOptions.length == 0 ? 'Selecione as tags...' : ''}
        backspaceRemovesValue={false} 
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        noOptionsMessage={() => "Nenhuma tag encontrada..."}
        components={{
            Control: TagControl,
            MultiValue: () => null as ReactNode,
            Option: TagOption,
        }}
        value={selectedOptions}
        inputValue={inputValue}
        onInputChange={(value:string, action:any) => {        
            if (action.action === "input-change") setInputValue(value);
        }}
    />
    </>
}